import React, { useMemo, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";
import EnterpriseGridCommon from "./Ag-Grid";
import { logDataHelperFunctions } from "../../helpers/Ag-Grid-helper"

const PipeDetails = ({
  rows,
  isLoading,
  handleRowClick,
  showRowSelection,
  onRowSelected,
}) => {
  const { t } = useTranslation();

  const [columnDefs] = useState([
    {
      headerName: t("pipestatusTable.siNo"),
      field: "slNo",
      key: "slNo",
      minWidth: 100,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("pipestatusTable.pipeID"),
      field: "pipeID",
      key: "pipeID",
      minWidth: 250,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },

      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("pipestatusTable.EndA"),
      field: "endA",
      key: "endA",
      minWidth: 100,
      pivot: true,
      floatingFilter: true,
      cellRenderer: (params) =>
        logDataHelperFunctions.getIconForStatus(params.value),
      filter: "agMultiColumnFilter",
      pivotComparator: (a, b) => b.localeCompare(a),
      filterParams: {
        filters: [
          {
            filter: "agSetColumnFilter",
            filterParams: {
              cellHeight: 40,
              cellRenderer: (params) => {
                const status = String(params.value);
                if (status === "(Select All)") {
                  return "(Select All)";
                }
                return logDataHelperFunctions.getIconForStatus(params.value);
              },
              valueFormatter: (params) => {
                const status = String(params.value);
                return status;
              },
            },
          },
        ],
        maxNumConditions: 1,
      },
    },
    {
      headerName: t("pipestatusTable.EndB"),
      field: "endB",
      key: "endB",
      minWidth: 100,
      pivot: true,
      floatingFilter: true,
      cellRenderer: (params) =>
        logDataHelperFunctions.getIconForStatus(params.value),
      filter: "agMultiColumnFilter",
      pivotComparator: (a, b) => b.localeCompare(a),
      filterParams: {
        filters: [
          {
            filter: "agSetColumnFilter",
            filterParams: {
              cellHeight: 40,
              cellRenderer: (params) => {
                const status = String(params.value);
                if (status === "(Select All)") {
                  return "(Select All)";
                }
                return logDataHelperFunctions.getIconForStatus(params.value);
              },
              valueFormatter: (params) => {
                const status = String(params.value);
                return status;
              },
            },
          },
        ],
        maxNumConditions: 1,
      },

    },
    {
      headerName: t("pipestatusTable.spread"),
      field: "spread",
      key: "spread",
      minWidth: 100,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("pipestatusTable.subSpread"),
      field: "subSpread",
      key: "subSpread",
      minWidth: 100,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("pipestatusTable.pipeStatus"),
      field: "status",
      key: "status",
      minWidth: 100,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
  ]);

  const onRowClicked = (params) => {
    console.log("Row clicked", params);
    handleRowClick(params.data);
  };

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }
    return params.value;
  };
  const memoizedRows = useMemo(() => {
    return rows?.filter(row => row && Object.keys(row).length > 0) || [];
  }, [rows]);


  return (
    <div
      className="ag-theme-alpine slog-grid-container"
      style={{ width: "100%" }}
    >
      <EnterpriseGridCommon
        rows={memoizedRows}
        columnDefs={columnDefs}
        isLoading={isLoading}
        onRowClicked={onRowClicked}
        exportFileName={"Pipe_Data"}
        processCellCallback={processCellCallback}
        heightValue={-295}
        slogData={true}
        showRowSelection={showRowSelection}
        onRowSelected={onRowSelected}
        getRowId={params => params.data.pipeID}
      />
    </div>
  );
};

export default PipeDetails;
